// @ts-nocheck
export default {
    getterDefaultDeliveryFeeGroup: (state) => state.workerDeliveryFeeGroupList.filter((group) => group.isDefault)[0],
    getterDefaultCashAutoDeductGroup: (state) => state.workerCashAutoDeductGroupList.filter((group) => group.isDefault)[0],
};
